"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateAllRows = exports.getSubsetOfItems = exports.getSortClassName = exports.isSortable = exports.isConfObject = exports.isCollapsed = exports.sortData = exports.groupData = exports.formatData = void 0;

var _react = _interopRequireDefault(require("react"));

var _groupBy = _interopRequireDefault(require("lodash/groupBy"));

var _orderBy = _interopRequireDefault(require("lodash/orderBy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var formatData = function formatData(_ref) {
  var data = _ref.data,
      groupByIteratee = _ref.groupByIteratee,
      sortByShape = _ref.sortByShape,
      requiredGroups = _ref.requiredGroups;
  var sortedData = sortData(data, sortByShape);
  return groupData(sortedData, groupByIteratee, requiredGroups);
};
/**
 * @desc
 * Re-create the data flow by grouping the data into blocks.
 *
 * @param data
 * @param groupByIteratee
 * @param requiredGroups
 * @returns Object
 * */


exports.formatData = formatData;

var groupData = function groupData(data, groupByIteratee, requiredGroups) {
  if (groupByIteratee) {
    var unSortedGroups = (0, _groupBy.default)(data, groupByIteratee);

    if (requiredGroups.length > 0) {
      // If there are required groups defined, generate them as groups and merge the default groups into them
      var required = requiredGroups.reduce(function (groups, item) {
        return _objectSpread(_objectSpread({}, groups), {}, _defineProperty({}, item, []));
      }, {});
      unSortedGroups = _objectSpread(_objectSpread({}, required), unSortedGroups);
    } // Order the groups by descending order


    return Object.keys(unSortedGroups).sort(function (a, b) {
      if (a > b) {
        return -1;
      }

      if (a < b) {
        return 1;
      }

      return 0;
    }).reduce(function (sortedGroup, sortedItemKey) {
      return _objectSpread(_objectSpread({}, sortedGroup), {}, _defineProperty({}, sortedItemKey, unSortedGroups[sortedItemKey]));
    }, {});
  }

  return data;
};
/**
 * @desc
 * Return sorted and ordered data by the sorted shape.
 *
 * @param data
 * @param sortByShape
 * @returns Array
 * */


exports.groupData = groupData;

var sortData = function sortData(data, sortByShape) {
  if (sortByShape) {
    var sortCol = sortByShape.sortCol,
        sortOrder = sortByShape.sortOrder;
    return (0, _orderBy.default)(data, [sortCol], [sortOrder]);
  }

  return data;
};
/**
 * @desc
 * Returns true if the groupId is in collapsed array.
 *
 * @param groupId
 * @param collapsed
 * @returns Bool
 * */


exports.sortData = sortData;

var isCollapsed = function isCollapsed(groupId, collapsed) {
  return collapsed.indexOf(groupId) !== -1;
};
/**
 * @desc
 * Checks if the argument is an object, but is not a React element.
 *
 * @param obj
 * @returns Bool
 * */


exports.isCollapsed = isCollapsed;

var isConfObject = function isConfObject(obj) {
  return obj !== null && _typeof(obj) === 'object' && !_react.default.isValidElement(obj);
};
/**
 * @desc
 * Checks if the cell is sortable by global and by a specific field configuration.
 *
 * @param sortable
 * @param sortableCell
 * @returns Bool
 * */


exports.isConfObject = isConfObject;

var isSortable = function isSortable(sortable, sortableCell) {
  return sortable && sortableCell !== false;
};
/**
 * @desc
 * Returns className for TH tags when sorting is turned on.
 *
 * @param name
 * @param sortByShape
 * @returns String
 * */


exports.isSortable = isSortable;

var getSortClassName = function getSortClassName(name, sortByShape) {
  return sortByShape && sortByShape.sortCol === name ? "sort ".concat(sortByShape.sortOrder) : 'sort';
};
/*
Extracts the groups between `minIndex` and `maxIndex` (currentPageIndexes).
Matching groups may lose some of their items, the parent-children relations, however, have to stay.
 */


exports.getSortClassName = getSortClassName;

var getSubsetOfItems = function getSubsetOfItems(_ref2) {
  var data = _ref2.data,
      minIndex = _ref2.minIndex,
      maxIndex = _ref2.maxIndex,
      _ref2$isGroup = _ref2.isGroup,
      isGroup = _ref2$isGroup === void 0 ? true : _ref2$isGroup;

  if (!data) {
    return data;
  }

  if (!isGroup) {
    return cutArray({
      data: data,
      cutStart: minIndex,
      cutEnd: maxIndex,
      isGroup: false
    });
  }

  var keys = Object.keys(data);
  var index = 0; // current index -> one iteration = one group, so we will increase this index by the length of iterated group.

  var result = {};

  for (var i = 0; i < keys.length; i += 1) {
    var length = data[keys[i]].length;
    var nextIndex = index + length;

    if (index < minIndex) {
      // the group is not in next pages
      if (nextIndex > minIndex) {
        // a part of the group is in current page (but the starting part was on the previous page)
        if (nextIndex <= maxIndex) {
          // the end-part of the group is in current page -> LET'S CUT THE PART ON PREVIOUS PAGES
          result[keys[i]] = cutArray({
            data: data[keys[i]],
            cutStart: minIndex - index
          });
          index += length;
        } else {
          // the group is too large (the current page contains some middle part of the group - neither the beginning nor the ending
          // LET'S CUT THE PART ON PREVIOUS PAGES & ON NEXT PAGES
          result[keys[i]] = cutArray({
            data: data[keys[i]],
            cutStart: minIndex - index,
            cutEnd: nextIndex - maxIndex
          });
          index += length;
          break;
        }
      } else {
        // the group was displayed on previous pages (with its ending) -> IGNORED
        index += length;
      }
    } else if (index < maxIndex) {
      // the beginning of the group is about to be displayed in the current page
      if (nextIndex < maxIndex) {
        // the current page has some remaining space for the whole group -> NO CUTTING
        result[keys[i]] = data[keys[i]];
        index += length;
      } else {
        // the current page has no more space for rendering this group, so its ending will be displayed on next pages.
        // LET'S CUT THE ENDING
        result[keys[i]] = cutArray({
          data: data[keys[i]],
          cutEnd: maxIndex - index
        });
        index += length;
      }
    } else {
      // the group (start) will be fully rendered on next pages,
      // therefore we can break the loop as we do not need to check next groups.
      break;
    }
  }

  return result;
};
/*
Cuts an array and returns the result. Does not mutate.
 */


exports.getSubsetOfItems = getSubsetOfItems;

var cutArray = function cutArray(_ref3) {
  var data = _ref3.data,
      cutStart = _ref3.cutStart,
      cutEnd = _ref3.cutEnd,
      _ref3$isGroup = _ref3.isGroup,
      isGroup = _ref3$isGroup === void 0 ? true : _ref3$isGroup;

  if (!isGroup) {
    return data.filter(function (value, index) {
      return index >= cutStart && index < cutEnd;
    });
  }

  if (cutStart && cutEnd) {
    return data.filter(function (value, index) {
      return index >= cutStart && index < data.length - cutEnd;
    });
  }

  if (cutStart) {
    return data.filter(function (value, index) {
      return index >= cutStart;
    });
  }

  if (cutEnd) {
    return data.filter(function (value, index) {
      return index < cutEnd;
    });
  }

  return data;
};
/*
Scans all shallow array items and returns its count.
 */


var calculateAllRows = function calculateAllRows(data) {
  var result = 0;

  if (Array.isArray(data)) {
    return data.length;
  }

  Object.keys(data).forEach(function (obj) {
    result += data[obj].length;
  });
  return result;
};

exports.calculateAllRows = calculateAllRows;
//# sourceMappingURL=utils.js.map